<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="font-family:Times New Roman;">Dedication</h1>
<p>I dedicate this book to my children and grandchildren in the hope that by reading about these adventures, they will learn more about the values of their father and grandfather, and that they will be encouraged to seek the spiritual connection that water, wildlife, and wilderness can give.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?114c6908